
import Permissions from '../components/Permissions';



export default Permissions;